import { colors, fonts } from '@grupoboticario/flora-tokens/dist/altoContraste/web/ds'

export const altoContraste = {
  colors,
  fonts,
}
